import { client } from '../../config';
import { DeliveryOption } from '../../models/delivery-options/delivery-option';
import { getPrice } from '../../routes/parcel-delivery/helpers';
import { store } from '../../stores/store';
import { isMeest } from '../../utils/client/client.utils';
import { EcommerceItem } from './types';

export function prepareEcommerceItem(): EcommerceItem {
  const {
    countryDeparture,
    countryDestination,
    navigation,
    promocode,
    shipment,
    selectedDeliveryOption,
  } = store.parcelCreationStore;

  const ecommerceItem: EcommerceItem = {
    item_id:
      `${countryDeparture?.code}_${countryDestination?.code}`.toLocaleLowerCase(),
    item_name: `${countryDeparture?.code}_${countryDestination?.code}`,
    item_category: store.localizationsStore.selectedCountry?.country_code,
    quantity: 1,
    price: 1,
  };

  const totalPrice = shipment?.price?.total_price;

  if (shipment && totalPrice) {
    ecommerceItem.price = totalPrice;
  }

  if (shipment?.converted_price?.currency) {
    ecommerceItem.currency = shipment?.converted_price?.currency;
  }

  if (selectedDeliveryOption?.selectedFirstMile) {
    ecommerceItem.first_mile = `${selectedDeliveryOption.selectedFirstMile.carrier.name}, ${selectedDeliveryOption.selectedFirstMile.service.name}`;
  }

  if (selectedDeliveryOption?.middle_mile) {
    ecommerceItem.last_mile =
      selectedDeliveryOption.middle_mile.delivery_method.toLocaleLowerCase();
  }

  if (selectedDeliveryOption?.selectedLastMile) {
    ecommerceItem.last_mile = `${selectedDeliveryOption.selectedLastMile.carrier.name}, ${selectedDeliveryOption.selectedLastMile.service.name}`;
  }

  if (shipment?.sender?.carrier.delivery_service.service_type) {
    if (
      navigation.map.map((step) => step.name).includes('sender-details-pudo')
    ) {
      ecommerceItem.sender_type = 'pudo';
    }

    if (
      navigation.map.map((step) => step.name).includes('sender-details-courier')
    ) {
      ecommerceItem.sender_type = 'courier';
    }

    if (
      navigation.map
        .map((step) => step.name)
        .includes('sender-details-concierge')
    ) {
      ecommerceItem.sender_type = 'concierge';
    }
  }

  if (shipment?.recipient?.carrier.delivery_service.service_type) {
    ecommerceItem.receiver_type = navigation.map
      .map((step) => step.name)
      .includes('receiver-details-pudo')
      ? 'pudo'
      : 'courier';
  }

  if (shipment?.items?.at(0)) {
    ecommerceItem.product_category = shipment?.items
      ?.map((item) => item.description_standart)
      .join(', ');

    ecommerceItem.total_declare_value = shipment?.items
      ?.map((i) => i.value)
      ?.reduce((prev, cur) => cur + prev);
  }

  if (shipment?.insurance) {
    ecommerceItem.insurance_amount = shipment?.insurance;
  }

  if (promocode?.code) {
    ecommerceItem.coupon = promocode?.code;
    ecommerceItem.discount = promocode?.discount;
  }

  return ecommerceItem;
}

export function prepareEcommerceItemForCalculator(
  deliveryOption?: DeliveryOption
): EcommerceItem {
  const { countryDeparture, countryDestination } = store.widgetCalculatorStore;

  const ecommerceItem: EcommerceItem = {
    item_id:
      `${countryDeparture?.code}_${countryDestination?.code}`.toLocaleLowerCase(),
    item_name: `${countryDeparture?.code}_${countryDestination?.code}`,
    item_category: store.localizationsStore.selectedCountry?.country_code,
    quantity: 1,
    price: 1,
  };

  if (deliveryOption) {
    ecommerceItem.price = getPrice(deliveryOption);
    ecommerceItem.first_mile = `${deliveryOption.selectedFirstMile?.carrier.name}, ${deliveryOption.selectedFirstMile?.service.name}`;
    ecommerceItem.middle_mile =
      deliveryOption.middle_mile.delivery_method.toLocaleLowerCase();
  }

  return ecommerceItem;
}

export const getMeasurementId = () =>
  isMeest(client) ? 'G-494F8L3JR3' : 'G-0XS4TEVWTK';
